/**
 * Labstep
 *
 * @module components/EntityUser/Action/Menu
 * @desc Action Menu for EntityUser
 */

import { EntityUserActionToggleAssign } from 'labstep-web/components/EntityUser/Action/ToggleAssign';
import { ActionMenu as ActionsMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { IEntityUserActionMenuProps } from './types';

export enum Action {
  toggle_assign = 'toggle_assign',
}

export const EntityUserActionMenu: React.FC<
  IEntityUserActionMenuProps
> = ({ entityUser, type, actions = [], entity }) => {
  return (
    <ActionsMenu type={type}>
      {actions.includes(Action.toggle_assign) && (
        <EntityUserActionToggleAssign
          entity={entity}
          actionComponentProps={{ type: 'option' }}
          entityUser={entityUser}
        />
      )}
    </ActionsMenu>
  );
};

EntityUserActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
